import { TableColumnsType } from 'antd';
import { useTranslation } from 'react-i18next';

const useGroupSearchColumns = ({ sorter = true }): TableColumnsType<any> => {
  const { t } = useTranslation('Vindoc');

  return [
    {
      title: t('Group Name'),
      width: 200,
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
    },
    /*     {
      title: t('Status'),
      width: 70,
      dataIndex: 'active',
      key: 'active',
      ellipsis: true,
      render: (active) => active ? 'Active' : 'Inactive',
    }, */
    // {
    //   title: t('Institution'),
    //   dataIndex: ['institution', 'name'],
    //   key: 'institution.name',
    //   width: 180,
    //   ellipsis: true,
    // },
  ];
};

export default useGroupSearchColumns;
